module.exports = __webpack_public_path__ + "img/add.5b5a189a.svg";